// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"8adad0c2","126":"79c62340","608":"ad90ea4d"}[chunkId] + ".chunk.js";
};